<template>
  <div class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h1 class="mb-1">Non-completed Company Orders</h1>
        <p class="text-muted mb-0">
          Consolidated admin view across all companies.
        </p>
      </div>
    </div>

    <CompanyOrdersComponent :is_admin="true" :loadNonCompletedOnly="true" />
  </div>
</template>

<script setup lang="ts">
import CompanyOrdersComponent from "@/dashboard/inventory_management/company_orders/CompanyOrdersComponent.vue";
</script>
